import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

// ******************************************
//     コメント区分（チェックボックス）
// ******************************************
export class CustomCheckBox extends Plugin {
  init() {
    const editor = this.editor;
    // 一旦すべてのスタイルを削除：SPAで移動したとき状態が残るため
    const completeStyleElement = document.querySelector('#ckeditor-complete-comment-style');
    if (completeStyleElement) {
      completeStyleElement.remove();
    }
    const commentStyleElements = document.querySelectorAll('[id^="ckeditor-comment-style-"]');
    [].forEach.call(commentStyleElements, (element) => {
      element.remove();
    });

    editor.ui.componentFactory.add('customCheckbox', () => {
      // The button will be an instance of ButtonView.
      const button = new ButtonView();
      const bind = button.bindTemplate;

      // チェックボックス　表示データ
      button.setTemplate({
        tag: 'div',
        attributes: {
          class: 'ck-comment-category-checkbox',
        },
        children: [
          {
            tag: 'label',
            children: [editor.i18n.t('コメント区分')],
            attributes: {
              class: `lang-${editor.i18n.language}`,
            },
          },
          {
            tag: 'label',
            children: [
              {
                tag: 'input',
                attributes: {
                  type: 'checkbox',
                  id: 'chkbx1',
                  checked: 'true',
                  'data-category-id': '1',
                },
                on: {
                  // Views listen to DOM events and propagate them.
                  click: bind.to('clicked'),
                },
              },
              editor.i18n.t('懸案項目') + ' ',
            ],
            // tag: "input",
            attributes: {
              for: 'chkbx1',
              type: 'checkbox',
            },
          },
          {
            tag: 'label',
            children: [
              {
                tag: 'input',
                attributes: {
                  type: 'checkbox',
                  id: 'chkbx2',
                  checked: 'true',
                  'data-category-id': '2',
                },
                on: {
                  // Views listen to DOM events and propagate them.
                  click: bind.to('clicked'),
                },
              },
              ' ' + editor.i18n.t('研究所質問') + ' ',
            ],
            attributes: {
              for: 'chkbx2',
              type: 'checkbox',
            },
          },
          {
            tag: 'label',
            children: [
              {
                tag: 'input',
                attributes: {
                  type: 'checkbox',
                  id: 'chkbx3',
                  checked: 'true',
                  'data-category-id': '3',
                },
                on: {
                  // Views listen to DOM events and propagate them.
                  click: bind.to('clicked'),
                },
              },
              ' ' + editor.i18n.t('Prod.⇒原作') + ' ',
            ],
            attributes: {
              for: 'chkbx3',
              type: 'checkbox',
            },
          },
          {
            tag: 'label',
            children: [
              {
                tag: 'input',
                attributes: {
                  type: 'checkbox',
                  id: 'chkbx4',
                  checked: 'true',
                  'data-category-id': '4',
                },
                on: {
                  // Views listen to DOM events and propagate them.
                  click: bind.to('clicked'),
                },
              },
              ' ' + editor.i18n.t('原作⇒Prod.') + ' ',
            ],
            attributes: {
              for: 'chkbx4',
              type: 'checkbox',
            },
          },
          {
            tag: 'label',
            children: [
              {
                tag: 'input',
                attributes: {
                  type: 'checkbox',
                  id: 'chkbx5',
                  checked: 'true',
                  'data-category-id': '5',
                },
                on: {
                  // Views listen to DOM events and propagate them.
                  click: bind.to('clicked'),
                },
              },
              ' ' + editor.i18n.t('完了') + ' ',
            ],
            attributes: {
              for: 'chkbx5',
              type: 'checkbox',
            },
          },
          {
            tag: 'label',
            children: [
              {
                tag: 'input',
                attributes: {
                  type: 'checkbox',
                  id: 'chkbx8',
                  checked: 'true',
                  'data-category-id': '8',
                },
                on: {
                  // Views listen to DOM events and propagate them.
                  click: bind.to('clicked'),
                },
              },
              ' ' + editor.i18n.t('Validation HM用') + ' ',
            ],
            attributes: {
              for: 'chkbx8',
              type: 'checkbox',
            },
          },
          {
            tag: 'label',
            children: [
              {
                tag: 'input',
                attributes: {
                  type: 'checkbox',
                  id: 'chkbx9',
                  checked: 'true',
                  'data-category-id': '9',
                },
                on: {
                  // Views listen to DOM events and propagate them.
                  click: bind.to('clicked'),
                },
              },
              ' ' + editor.i18n.t('Validation 原作用') + ' ',
            ],
            attributes: {
              for: 'chkbx9',
              type: 'checkbox',
            },
          },
        ],
      });

      // チェックボックス　クリックイベント
      button.on('clicked', (evt, data) => {
        const inputCheckBox = document.getElementById(data.target.id);

        // すでに完了状態のスレッドIDを取得
        const getCompletedThreadIds = () => {
          const elements = document.querySelectorAll('div.ck-thread[iscomplete="true"]');
          return Array.from(elements).map((element) => {
            return element.getAttribute('data-thread-id');
          });
        };

        // 現在のチェックボックスの状態を取得
        const getCheckboxItems = () => {
          const checkboxElements = document.querySelectorAll('.ck-comment-category-checkbox input[type="checkbox"]');
          const checkedItems = Array.from(checkboxElements).map((element) => {
            return {
              categoryId: element.getAttribute('data-category-id'),
              checked: element.checked,
            };
          });
          return checkedItems;
        };

        // -----------------------------------------------------
        //   コメント欄の表示/非表示
        //   注：CKEditorが勝手にコメント欄を追加するため、<style>タグを追加/削除して対応せざるをえないです。
        // -----------------------------------------------------
        function displayComment(targetId) {
          // [完了]をチェック/アンチェックした場合
          if (targetId === 5) {
            const styleElementId = 'ckeditor-complete-comment-style';
            if (inputCheckBox.checked === true) {
              const targetStyleElement = document.getElementById(styleElementId);
              targetStyleElement.remove();
            } else {
              const hasStyleElement = document.getElementById(styleElementId);
              if (!hasStyleElement) {
                const styleElement = document.createElement('style');
                styleElement.id = styleElementId;
                styleElement.textContent = `.ck-sidebar-item:has(.ck-thread[iscomplete=true]) { display: none; }`;
                document.head.appendChild(styleElement);
              }
            }
            return;
          }

          // [完了]以外
          let elements = document.querySelectorAll('div[data-thread-id^="' + targetId + '"]');
          for (let i = 0; i < elements.length; i++) {
            const styleElementId = `ckeditor-comment-style-${targetId}`;
            if (inputCheckBox.checked == true) {
              const targetStyleElement = document.getElementById(styleElementId);
              if (targetStyleElement) {
                targetStyleElement.remove();
              }
            } else {
              const hasStyleElement = document.getElementById(styleElementId);
              if (!hasStyleElement) {
                const styleElement = document.createElement('style');
                styleElement.id = styleElementId;
                styleElement.textContent = `.ck-sidebar-item:has(.ck-thread[data-thread-id^="${targetId}"]) { display: none; }`;
                document.head.appendChild(styleElement);
              }
            }
          }
        }

        // -----------------------------------------------------
        //   CKEditor内のハイライトの表示/非表示
        //   ※commentCustom.css に記載
        // -----------------------------------------------------
        const displayMarker = () => {
          const completedThreadIds = getCompletedThreadIds(); // 完了状態のスレッドID
          const completeCategoryId = 5;
          const checkedItems = getCheckboxItems(); // すべてのチェックボックスの状態
          const completeCategoryItem = checkedItems.find((item) => {
            return Number(item.categoryId) === completeCategoryId;
          });
          const isCompleteChecked = completeCategoryItem && completeCategoryItem.checked === true; // 「完了」チェックボックスの状態
          checkedItems.forEach((checkedItem) => {
            const categoryId = checkedItem.categoryId;
            if (categoryId !== completeCategoryId) {
              // 完了以外
              const elements = document.querySelectorAll('span[data-comment^="' + categoryId + '"]');
              [].forEach.call(elements, (element) => {
                const threadId = element.getAttribute('data-comment');
                const isCompletedComment = completedThreadIds.includes(threadId);
                let showMarker = false;
                if (checkedItem.checked === true) {
                  if (isCompleteChecked === true && isCompletedComment === true) {
                    showMarker = true;
                  } else if (isCompletedComment === false) {
                    showMarker = true;
                  } else {
                    showMarker = false;
                  }
                }

                element.className = showMarker == true ? 'ck-comment-marker' : '';
              });
            }
          });
        };

        const targetId = Number(data.target.getAttribute('data-category-id'));

        if (targetId) {
          displayComment(targetId);
          displayMarker();
        } else {
          console.error('data-category-id is not found.');
        }
      });
      return button;
    });
  }
}
